// extracted by mini-css-extract-plugin
module.exports = {"buttons":"LogisticsConfirmModal_buttons__3CsUQ"};